import { CustomerCountry } from "../address/address";

export const Validation: {
    readonly ZipRegEx: Record<CustomerCountry, RegExp>;
    readonly PhoneRegEx: Record<CustomerCountry, RegExp>;
    readonly IdNoRegEx: RegExp;
    readonly VatNoRegEx: RegExp;
    readonly EmailRegEx: RegExp;
} = {
    ZipRegEx: {
        CZ: /^[1-7]\d{4}$/,
        SK: /^[089]\d{4}$/,
        DE: /^\d{5}$/,
        AT: /^\d{4}$/,
        PL: /^\d{2}-?\d{3}$/,
        FR: /^\d{5}$/,
        UK: /^\w+$/,
        // IT: /^\d{5}$/,
        // NO: /^\d{4}$/,
        // NL: /^\d{4}(\s)?[A-z]{2}$/,
        // HU: /^\d{4}$/,
        // DK: /^\d{4}$/,
        // CH: /^\d{4}$/,
    },
    PhoneRegEx: {
        CZ: /^[2-7]\d{8}$/,
        SK: /^[29]\d{8}$/,
        DE: /^\d+$/,
        AT: /^\d+$/,
        PL: /^\d+$/,
        FR: /^\d+$/,
        UK: /^\d+$/,
    },
    IdNoRegEx: /^\d{8}$/,
    VatNoRegEx: /^\w{2}\d{8,10}$/,
    EmailRegEx: /^[\w!#$%&'*+./=?^`{|}~-]+@[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?(?:\.[\dA-Za-z](?:[\dA-Za-z-]{0,61}[\dA-Za-z])?)+$/,
};
